const FETCH_DEVICE_UPTIME_REPORT = "device-uptime-report::fetch";
const FETCH_DEVICE_UPTIME_REPORT_SUCCESS =
  "device-uptime-report:fetch::success";
const UNLOAD_DEVICE_UPTIME_REPORT = "device-uptime-report::unload";

function fetchDeviceUptimeReportAction(args) {
  const { resolve, reject, serviceArgs } = args;
  const { start, end, deviceId } = serviceArgs;

  return {
    type: FETCH_DEVICE_UPTIME_REPORT,
    payload: {
      resolve,
      reject,
      serviceArgs: [deviceId, start, end],
    },
  };
}

const unloadDeviceUptimeReportAction = {
  type: UNLOAD_DEVICE_UPTIME_REPORT,
};

export {
  fetchDeviceUptimeReportAction,
  unloadDeviceUptimeReportAction,
  FETCH_DEVICE_UPTIME_REPORT,
  FETCH_DEVICE_UPTIME_REPORT_SUCCESS,
  UNLOAD_DEVICE_UPTIME_REPORT,
};
